const header  = document.getElementById('app');
const announcement = document.querySelector("#announcement");
const rect = announcement.getBoundingClientRect();;


addClassHeader = () => {
    header.classList.add("sticky");
}

removeClassHeader = () => {
    header.classList.remove("sticky");
}
if(window.matchMedia('(max-width: 768px)').matches) {
    window.addEventListener('scroll', function () {
        let getScrollposition = window.scrollY;
        if (getScrollposition > rect.height) {
            addClassHeader();
        } else {
            removeClassHeader();
        }
    });
}